// Subtle "bad connection" glitches for employee images. Each employee
// figure with a pixel/hover image occasionally flickers on its own random
// schedule: usually just a brief blip of the pixel version, now and then a
// little flutter. It only runs while the image is in view and not hovered.

(function () {
    var SELECTOR = '.employee-list figure.has-hover-image';

    // Glitch classes (defined in CSS) with relative weights — subtle ones
    // are far more common than the hectic burst.
    var GLITCHES = [
        { cls: 'glitch-blip', weight: 6 },
        { cls: 'glitch-double', weight: 3 },
        { cls: 'glitch-flutter', weight: 2 },
        { cls: 'glitch-burst', weight: 1 }
    ];

    var TOTAL_WEIGHT = GLITCHES.reduce(function (sum, g) {
        return sum + g.weight;
    }, 0);

    // Random pause between glitches, in ms.
    var MIN_DELAY = 4000;
    var MAX_DELAY = 15000;

    function randomBetween(min, max) {
        return min + Math.random() * (max - min);
    }

    function pickGlitch() {
        var r = Math.random() * TOTAL_WEIGHT;
        for (var i = 0; i < GLITCHES.length; i++) {
            r -= GLITCHES[i].weight;
            if (r <= 0) {
                return GLITCHES[i].cls;
            }
        }
        return GLITCHES[0].cls;
    }

    function scheduleNext(figure) {
        figure._glitchTimer = setTimeout(function () {
            trigger(figure);
        }, randomBetween(MIN_DELAY, MAX_DELAY));
    }

    function trigger(figure) {
        // Skip (but keep the loop alive) when it wouldn't be seen or would
        // fight the hover state.
        if (!figure._inView || document.hidden || figure.matches(':hover')) {
            scheduleNext(figure);
            return;
        }

        var cls = pickGlitch();
        figure.classList.add(cls);

        var done = function () {
            figure.classList.remove(cls);
            figure.removeEventListener('animationend', done);
            clearTimeout(figure._glitchFallback);
            scheduleNext(figure);
        };

        figure.addEventListener('animationend', done);
        // Fallback in case animationend never fires.
        figure._glitchFallback = setTimeout(done, 1200);
    }

    function setup() {
        var figures = document.querySelectorAll(SELECTOR);
        if (!figures.length) {
            return;
        }

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    entry.target._inView = entry.intersectionRatio > 0;
                });
            }, { root: null, rootMargin: '0px', threshold: 0 });

            figures.forEach(function (figure) {
                figure._inView = false;
                observer.observe(figure);
                scheduleNext(figure);
            });
        } else {
            figures.forEach(function (figure) {
                figure._inView = true;
                scheduleNext(figure);
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }
})();
